module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-Regular_8718deec.d7ec7158.ttf";